import {
  ParametroFactorConversionComponent
} from './views/parametro-factor-conversion/parametro-factor-conversion.component';
import {TiposOrdenesBalanzaComponent} from './views/tipos-ordenes-balanza/tipos-ordenes-balanza.component';
import {MantenimientoBasculasComponent} from './views/mantenimiento-basculas/mantenimiento-basculas.component';
import {
  OrdenesReferenciaMaquinaComponent
} from './views/ordenes-referencia-maquina/ordenes-referencia-maquina.component';
import {
  TicketAutorizacionTransporteComponent
} from './views/ticket-autorizacion-transporte/ticket-autorizacion-transporte.component';
import {MantenimientoGaritasComponent} from './views/mantenimiento-garitas/mantenimiento-garitas.component';
import {NotificacionesComponent} from './views/notificaciones/notificaciones.component';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {OrdenesDeBalanzaComponent} from './views/ordenes-de-balanza/ordenes-de-balanza.component';
import {DesbloqueoOrdenBalanzaComponent} from './views/desbloqueo-orden-balanza/desbloqueo-orden-balanza.component';
import {
  DesbloqueoOrdenBalanzaCalidadComponent
} from './views/desbloqueo-orden-balanza-calidad/desbloqueo-orden-balanza-calidad.component';
import {ParametrizarValorFleteComponent} from './views/parametrizar-valor-flete/parametrizar-valor-flete.component';
import {
  PorcentajeMermaAsigClientComponent
} from './views/porcentaje-merma-asig-client/porcentaje-merma-asig-client.component';
import {UsuarioBasculaGaritaComponent} from './views/usuario-bascula-garita/usuario-bascula-garita.component';
import {
  PorcentajeToleranciaNivelesPesoComponent
} from './views/porcentaje-tolerancia-niveles-peso/porcentaje-tolerancia-niveles-peso.component';
import {NotaMaquilaComponent} from './views/nota-maquila/nota-maquila.component';
import {
  ConfiguracionMotivosDeDesbloqueosComponent
} from './views/configuracion-motivos-de-desbloqueos/configuracion-motivos-de-desbloqueos.component';
import {UsuariosAprobadoresComponent} from './views/usuarios-aprobadores/usuarios-aprobadores.component';
import {
  ParametrizacionesDeCalidadRecibidaComponent
} from './views/parametrizaciones-de-calidad-recibida/parametrizaciones-de-calidad-recibida.component';
import {
  ParametrizacionesDeFactoresConversionComponent
} from './views/parametrizaciones-de-factores-conversion/parametrizaciones-de-factores-conversion.component';
import {
  MantenimientoOrigenesExtractorasComponent
} from './views/mantenimiento-origenes-extractoras/mantenimiento-origenes-extractoras.component';
import {KardexComponent} from './views/kardex/kardex.component';
import {ReporteriaComponent} from './views/reporteria/reporteria.component';
import {OrdenesDeBalanzaSalidaComponent} from './views/ordenes-de-balanza-salida/ordenes-de-balanza-salida.component';
import { MantenedorTanquerosComponent } from './views/mantenedor-tanqueros/mantenedor-tanqueros.component';
import { OrdenesCerradasComponent } from './views/ordenes-cerradas/ordenes-cerradas.component';
import { OrdenesCambiarEstadosComponent } from './views/ordenes-actualiza-estados/ordenes-actualiza-estados.component';
import { ReporteComprasComponent } from './views/reporte-compras/reporte-compras.component';
import { OrdenesReasignacionComponent } from './views/ordenes-reasignacion/ordenes-reasignacion.component';
import { MantenedorNivelesDobiComponent } from './views/mantenedor-niveles-dobi/mantenedor-niveles-dobi.component';
import { ReporteQmComponent } from './views/reporte-qm/reporte-qm.component';
import { ReporteGaritaComponent } from './views/reporte-garita/reporte-garita.component';


const garitasRoutes: Routes = [
  {
    path: 'balanza/garitas',
    component: MantenimientoGaritasComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/ticket-autorizacion-transporte',
    component: TicketAutorizacionTransporteComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/ordenes-referencia-maquila',
    component: OrdenesReferenciaMaquinaComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/mantenimiento-basculas',
    component: MantenimientoBasculasComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/tipo-orden-balanza',
    component: TiposOrdenesBalanzaComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/parametro-factor-conversion',
    component: ParametroFactorConversionComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/ordenes-de-balanza',
    component: OrdenesDeBalanzaComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/ordenes-de-balanza-salida',
    component: OrdenesDeBalanzaSalidaComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/desbloqueo-orden-balanza',
    component: DesbloqueoOrdenBalanzaComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/desbloqueo-orden-balanza-calidad',
    component: DesbloqueoOrdenBalanzaCalidadComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/porcentaje-merma-asig-cliente',
    component: PorcentajeMermaAsigClientComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/notificaciones',
    component: NotificacionesComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/parametrizar-valor-flete',
    component: ParametrizarValorFleteComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/usuario-bascula-garita',
    component: UsuarioBasculaGaritaComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/porcentaje-tolerancia-niveles-peso',
    component: PorcentajeToleranciaNivelesPesoComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/nota-maquila',
    component: NotaMaquilaComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/usuarios-aprobadores',
    component: UsuariosAprobadoresComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/configuracion-motivos-de-desbloqueos',
    component: ConfiguracionMotivosDeDesbloqueosComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/parametrizaciones-de-calidad-recibida',
    component: ParametrizacionesDeCalidadRecibidaComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/parametrizaciones-de-factores-conversion',
    component: ParametrizacionesDeFactoresConversionComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/mantenimiento-origenes-extractoras',
    component: MantenimientoOrigenesExtractorasComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/kardex',
    component: KardexComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/reporteria',
    component: ReporteriaComponent,
    // canActivate: [AuthGuard]
  },
  {
    path: 'balanza/tanqueros',
    component: MantenedorTanquerosComponent,
  },
  {
    path: 'balanza/ordenes-cerradas',
    component: OrdenesCerradasComponent,
  },
  {
    path: 'balanza/ordenes-actualizarestado',
    component: OrdenesCambiarEstadosComponent,
  },
  {
    path: 'balanza/reporte-compras',
    component: ReporteComprasComponent,
  },
  {
    path: 'balanza/reasignar-ordenes',
    component: OrdenesReasignacionComponent,
  },
  {
    path: "balanza/tipocalidad-dobi",
    component: MantenedorNivelesDobiComponent
  },
  {
    path: "balanza/reporte-qm",
    component: ReporteQmComponent
  },
  {
    path: "balanza/reporte-garita",
    component: ReporteGaritaComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(garitasRoutes)],
  exports: [RouterModule]
})
export class BalanzaRoutingModule {
}
